/**
 * QNステータスの定義
 */
export const QN_STATUS: QnStatusProps = {
  FILLING: 'FILLING',
  INFORMED: 'INFORMED',
  ASSIGNED: 'ASSIGNED',
  NOGUIDE: 'NOGUIDE',
  REASSIGNED: 'REASSIGNED',
  IMPASSE: 'IMPASSE',
  CHANGE_PARTNER: 'CHANGE_PARTNER',
  DISPATCHING: 'DISPATCHING',
  COMING_SOON: 'COMING_SOON',
  JOINED: 'JOINED',
  CLOSED: 'CLOSED',
  CANCELED: 'CANCELED',
  RESERVED: 'RESERVED',
}

/**
 * 型定義：QNステータス定義
 */
export type QnStatusProps = {
  [qnStatus: string]: string
}
